import React from 'react';

const Option = (props) => {
    return (<option value={props.value}>{props.title}</option>)
}

const SelectMenu = (props) => {

    if(!props.options) return '';


    const title = (props.title) ? (<option disabled value={props.title} key="title">{props.title}</option>) : null;

    const options = props.options.map(item => {
        return (<Option value={item.value} title={item.title} key={item.id}/>);
    })

    const all = (props.allowAll) ? (<option value="all" key="all">All</option>) : null;


    return(
        <select className="SelectMenu" name={props.name} onChange={props.onChange} defaultValue={props.title}>
            {title}
            {all}
            {options}
        </select>
    )
}
export default SelectMenu;
